import { Text, XStack } from 'tamagui'

import type { CabinetState } from '../../api/client'
import { useApp } from '../../i18n'
import { tone } from '../../theme/tones'

/**
 * Состояние договора глазами контрагента — пять значений вместо внутренних шагов
 * согласования. Общий компонент для списка и карточки: в списке он отвечает «где это
 * стоит» беглым взглядом, в карточке — тому, кто уже открыл документ.
 */
const STATE_TONE: Record<CabinetState, 'green' | 'red' | 'gold' | 'slate'> = {
  in_review: 'slate',
  awaiting_signed_copy: 'gold',
  signed: 'green',
  rejected: 'red',
  cancelled: 'red',
}

export function StateBadge({ state }: { state: CabinetState }) {
  const { l } = useApp()
  const c = tone(STATE_TONE[state])
  return (
    <XStack backgroundColor={c.soft} borderRadius={6} paddingHorizontal={8} paddingVertical={3}>
      <Text fontSize={12} fontWeight="600" color={c.text}>
        {l(`cab.state.${state}`)}
      </Text>
    </XStack>
  )
}
